import React, { useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import { Autoplay, Navigation, Thumbs } from "swiper/modules";

import "swiper/css";
import { useTranslation } from "react-i18next";
import CustomImageComponent from "../../components/CustomImageComponent";



const PropertyDetailSlider = (props) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  const { imageData } = props;
  const [imagesNavSlider, setImagesNavSlider] = useState(null);


  const images = imageData?.map(artifact => artifact.artifactPath) || [];

  return (
    <div className="product__slider">
      <div className="product__slider-main ">
        {images?.length > 0 && (
          <Swiper
            thumbs={{ swiper: imagesNavSlider }}
            dir={isRTL ? "rtl" : "ltr"}
            direction="horizontal"
            slidesPerView={1}
            spaceBetween={32}
            mousewheel={true}
            navigation={{
              nextEl: ".slider__next",
              prevEl: ".slider__prev",
            }}
            breakpoints={{
              0: {
                direction: "horizontal",
              },
              768: {
                direction: "horizontal",
              },
            }}
            autoplay={{
              delay: 250000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation, Thumbs]}
          >
            {images?.map((slide, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="slide">
                    <CustomImageComponent src={slide} alt={slide} className={"img-responsive"} />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>)}
      </div>
      <div className="product__slider-thumb">
        {images?.length > 0 && (
          <Swiper
            onSwiper={setImagesNavSlider}
            direction="vertical"
            spaceBetween={24}
            slidesPerView={4}
            navigation={{
              nextEl: ".slider__next",
              prevEl: ".slider__prev",
            }}
            breakpoints={{
              0: {
                direction: "horizontal",
              },
              768: {
                direction: "vertical",
              },
            }}
          >
            {images.map((slide, index) => {
              return (
                <SwiperSlide key={index}>
                  <div>
                    <CustomImageComponent src={slide} alt={slide} className={"img-responsive"} />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        <div className="arrow">
          <a className="slider__next  prev">&nbsp;</a>
          <a className="slider__prev next">&nbsp;</a>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetailSlider;
